import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultDestinationSettings = {
    isTypeaheadInputFocus: false
};

function useDestinationSettings(props) {
    const {
        destinationSettings: propsDestinationSettings
    } = props;

    const {
        initialSettings: initialDestinationSettings,
        settings: destinationSettings,
        changeSettings: changeDestinationSettings
    } = useSettings(defaultDestinationSettings, propsDestinationSettings);

    const result = {
        initialDestinationSettings,
        destinationSettings,
        changeDestinationSettings
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSettings};
